module.exports = __webpack_public_path__ + "static/media/document-icon.177999e7.svg";